import React from "react";
import { Switch, Route, Redirect } from "react-router";

import Dashboard from "../dashboard/dashboard";
import Usuario from "../usuario/usuario";
import Empresa from "../empresa/empresa";
import Cliente from "../cliente/cliente";
import Empenho from "../empenho/empenho";
import FaturaAdm from "../fatura/faturaAdm";
import FaturaCliente from "../fatura/faturaCliente";
import FaturaEngenharia from "../fatura/faturaEngenharia";
import FaturaVerificadorIcmsEnergia from "../fatura/faturaVerificadorIcmsEnergia";
import FaturaRelatorio from "../faturaRelatorio/faturaRelatorio";
import Geracao from "../geracao/geracao";
import GeracaoIntegracao from "../geracaoIntegracao/geracaoIntegracao";
import ConsumoIntegracao from "../consumoIntegracao/consumoIntegracao";
import GeracaoLeitura from "../geracaoLeitura/geracaoLeitura";
import Analise from "../analise/analise";
import DemandaContrato from "../demandaContrato/demandaContrato";
import Rede from "../rede/rede";
import Documento from "../documento/documento";
import DocumentoAdm from "../documentoAdm/documentoAdm";
import DocumentoCliente from "../documento/documentoCliente";
import RedeVisualizacao from "../rede/redeVisualizacao";
import GestaoProcesso from "../gestaoProcesso/gestaoProcesso";
import Tributacao from "../tributacao/tributacao";
import Concessionaria from "../concessionaria/concessionaria";
import PlataformaMercadoLivre from "../plataformaMercadoLivre/plataformaMercadoLivre";
import GestorConcessionaria from "../gestorConcessionaria/gestorConcessionaria";
import MonitoramentoConsumo from "../monitoramentoConsumo/monitoramentoConsumo";
import GestaoCreditoSolar from "../gestaoCreditoSolar/gestaoCreditoSolar";
import DiagnosticoEnergia from "../diagnosticoEnergia/diagnosticoEnergia";
import ContratoAluguel from "../contratoAluguel/contratoAluguel";
import ContratoMercadoLivre from "../contratoMercadoLivre/contratoMercadoLivre";
import AccessDenied from "./accessDenied";

export default (props) => {
    const sessao = props.sessao || {};

    const acessoDashboard = sessao.acesso_modulo_dashboard;

    const acessoUsuario =
        sessao.acesso_modulo_usuario &&
        (sessao.acesso_usuario_visualizar ||
            sessao.acesso_usuario_adicionar ||
            sessao.acesso_usuario_editar ||
            sessao.acesso_usuario_excluir ||
            sessao.acesso_usuario_permissao ||
            sessao.acesso_usuario_permissao_administrador ||
            sessao.acesso_usuario_editar_administrador ||
            sessao.acesso_usuario_excluir_administrador);

    const acessoEmpresa = sessao.administrador && !sessao.id_cliente && !sessao.id_empresa;

    const acessoCliente =
        sessao.acesso_modulo_cliente &&
        !sessao.acesso_cliente &&
        (sessao.acesso_cadastro_cliente_visualizar || sessao.acesso_cadastro_cliente_adicionar || sessao.acesso_cadastro_cliente_editar || sessao.acesso_cadastro_cliente_excluir);

    const acessoConcessionaria =
        sessao.acesso_modulo_concessionaria &&
        !sessao.acesso_cliente &&
        (sessao.acesso_concessionaria_visualizar || sessao.acesso_concessionaria_adicionar || sessao.acesso_concessionaria_editar || sessao.acesso_concessionaria_excluir);

    const acessoPlataformaMercadoLivre =
        sessao.acesso_modulo_plataforma_mercado_livre &&
        !sessao.acesso_cliente &&
        (sessao.acesso_plataforma_mercado_livre_adicionar || sessao.acesso_plataforma_mercado_livre_editar);

    const acessoEmpenho =
        sessao.acesso_modulo_empenho &&
        !sessao.acesso_cliente &&
        (sessao.acesso_empenho_visualizar || sessao.acesso_empenho_adicionar || sessao.acesso_empenho_editar || sessao.acesso_empenho_excluir);

    const acessoDocumento = sessao.acesso_modulo_documento && (sessao.acesso_documento_visualizar || sessao.acesso_documento_editar);

    const acessoDemandaContrato =
        sessao.acesso_modulo_demanda_contrato &&
        !sessao.acesso_cliente &&
        (sessao.acesso_cadastro_demanda_visualizar || sessao.acesso_cadastro_demanda_adicionar || sessao.acesso_cadastro_demanda_editar || sessao.acesso_cadastro_demanda_excluir);

    const acessoMercadoLivre =
        sessao.acesso_modulo_contrato_mercado_livre &&
        (sessao.acesso_contrato_mercado_livre_visualizar ||
            sessao.acesso_contrato_mercado_livre_adicionar ||
            sessao.acesso_contrato_mercado_livre_editar ||
            sessao.acesso_contrato_mercado_livre_excluir);

    const acessoGestorConcessionaria =
        sessao.acesso_modulo_gestor_concessionaria &&
        (sessao.acesso_gestor_concessionaria_visualizar ||
            sessao.acesso_gestor_concessionaria_adicionar ||
            sessao.acesso_gestor_concessionaria_editar ||
            sessao.acesso_gestor_concessionaria_excluir);

    const acessoContratoAluguel =
        sessao.acesso_modulo_contrato_aluguel &&
        (sessao.acesso_contrato_aluguel_visualizar || sessao.acesso_contrato_aluguel_adicionar || sessao.acesso_contrato_aluguel_editar || sessao.acesso_contrato_aluguel_excluir);

    const acessoGeracao =
        sessao.acesso_modulo_geracao &&
        !sessao.acesso_cliente &&
        (sessao.acesso_cadastro_geracao_visualizar || sessao.acesso_cadastro_geracao_adicionar || sessao.acesso_cadastro_geracao_editar || sessao.acesso_cadastro_geracao_excluir);

    const acessoGeracaoIntegracao = sessao.acesso_modulo_geracao_integracao && !sessao.acesso_cliente && (sessao.acesso_solar_visualizar || sessao.acesso_solar_editar);

    const acessoConsumoIntegracao =
        sessao.acesso_modulo_consumo_integracao && !sessao.acesso_cliente && (sessao.acesso_monitoramento_consumo_visualizar || sessao.acesso_monitoramento_consumo_editar);

    const acessoRede = sessao.acesso_modulo_rede && !sessao.acesso_cliente && (sessao.acesso_redes_visualizar || sessao.acesso_redes_editar);

    const acessoTributacao =
        sessao.acesso_modulo_tributacao &&
        !sessao.acesso_cliente &&
        (sessao.acesso_tributacao_visualizar || sessao.acesso_tributacao_adicionar || sessao.acesso_tributacao_editar || sessao.acesso_tributacao_excluir);

    const acessoFaturaAdm =
        sessao.administrador && sessao.acesso_modulo_fatura && (sessao.acesso_fatura_visualizar || sessao.acesso_fatura_editar || sessao.acesso_fatura_editar_fechado);

    const acessoGestaoProcesso =
        sessao.acesso_modulo_gestao_tarefa &&
        !sessao.acesso_cliente &&
        (sessao.acesso_gestao_processo_visualizar || sessao.acesso_gestao_processo_adicionar || sessao.acesso_gestao_processo_editar || sessao.acesso_gestao_processo_excluir);

    const acessoDocumentoAdm =
        sessao.administrador &&
        sessao.acesso_modulo_documento_adm &&
        (sessao.acesso_documento_adm_visualizar || sessao.acesso_documento_adm_adicionar || sessao.acesso_documento_adm_editar || sessao.acesso_documento_adm_excluir);

    const acessoFaturaCliente = sessao.acesso_modulo_fatura_cliente && (sessao.acesso_fatura_visualizar || sessao.acesso_fatura_editar || sessao.acesso_fatura_editar_fechado);

    const acessoFaturaEngenharia = sessao.acesso_modulo_fatura_engenharia && (sessao.acesso_multa_visualizar || sessao.acesso_multa_editar || sessao.acesso_multa_editar_fechado);

    const acessoFaturaIcmsEnergia = sessao.acesso_modulo_verificador_icms_energia && sessao.acesso_icms_energia_visualizar;

    const acessoFaturaRelatorio = sessao.acesso_modulo_fatura_relatorio && sessao.acesso_relatorio;

    const acessoAnalise = sessao.acesso_modulo_analise && sessao.acesso_analise;

    const acessoGestaoCreditoSolar = sessao.acesso_modulo_gestao_credito_solar && (!sessao.acesso_cliente || sessao.acesso_gestao_credito_solar_visualizar);

    const acessoDiagnosticoEnergia = sessao.acesso_modulo_diagnostico_energia && (!sessao.acesso_cliente || sessao.acesso_diagnostico_energia_visualizar);

    const acessoRedesEletricas = sessao.acesso_modulo_redes_eletricas && sessao.acesso_redes_visualizar;

    const acessoDocumentoCliente = sessao.acesso_modulo_documento_cliente && (sessao.acesso_documento_visualizar || sessao.acesso_documento_editar);

    const acessoGeracaoLeitura = sessao.acesso_modulo_geracao_leitura && (sessao.acesso_solar_visualizar || sessao.acesso_solar_editar);

    const acessoMonitoramentoConsumo = sessao.acesso_modulo_monitoramento_consumo && (sessao.acesso_monitoramento_consumo_visualizar || sessao.acesso_monitoramento_consumo_editar);

    return (
        <div id="id-content-wrapper" className="content-wrapper" style={{ backgroundColor: "#eee", paddingBlock: 5 }}>
            <Switch>
                <Route path="/dashboard" component={acessoDashboard ? Dashboard : AccessDenied} />
                <Route path="/usuario" component={acessoUsuario ? Usuario : AccessDenied} />
                <Route path="/empresa" component={acessoEmpresa ? Empresa : AccessDenied} />
                <Route path="/cliente" component={acessoCliente ? Cliente : AccessDenied} />
                <Route path="/concessionaria" component={acessoConcessionaria ? Concessionaria : AccessDenied} />
                <Route path="/plataforma-mercado-livre" component={acessoPlataformaMercadoLivre ? PlataformaMercadoLivre : AccessDenied} />
                <Route path="/gestor-concessionaria" component={acessoGestorConcessionaria ? GestorConcessionaria : AccessDenied} />
                <Route path="/empenho" component={acessoEmpenho ? Empenho : AccessDenied} />
                <Route path="/documento" component={acessoDocumento ? Documento : AccessDenied} />
                <Route path="/demanda-contrato" component={acessoDemandaContrato ? DemandaContrato : AccessDenied} />
                <Route path="/contrato-mercado-livre" component={acessoMercadoLivre ? ContratoMercadoLivre : AccessDenied} />
                <Route path="/contrato-aluguel" component={acessoContratoAluguel ? ContratoAluguel : AccessDenied} />
                <Route path="/geracao" component={acessoGeracao ? Geracao : AccessDenied} />
                <Route path="/geracao-integracao" component={acessoGeracaoIntegracao ? GeracaoIntegracao : AccessDenied} />
                <Route path="/consumo-integracao" component={acessoConsumoIntegracao ? ConsumoIntegracao : AccessDenied} />
                <Route path="/rede" component={acessoRede ? Rede : AccessDenied} />
                <Route path="/tributacao" component={acessoTributacao ? Tributacao : AccessDenied} />
                <Route path="/fatura" component={acessoFaturaAdm ? FaturaAdm : AccessDenied} />
                <Route path="/gestao-tarefa" component={acessoGestaoProcesso ? GestaoProcesso : AccessDenied} />
                <Route path="/documento-adm" component={acessoDocumentoAdm ? DocumentoAdm : AccessDenied} />
                <Route path="/fatura-cliente" component={acessoFaturaCliente ? FaturaCliente : AccessDenied} />
                <Route path="/fatura-engenharia" component={acessoFaturaEngenharia ? FaturaEngenharia : AccessDenied} />
                <Route path="/verificador-icms-energia" component={acessoFaturaIcmsEnergia ? FaturaVerificadorIcmsEnergia : AccessDenied} />
                {/* {acessoFaturaIcmsEnergia ? <Route path="/verificador-consumo-agua" component={ FaturaVerificadorIcmsEnergia} /> :null} */}
                <Route path="/fatura-relatorio" component={acessoFaturaRelatorio ? FaturaRelatorio : AccessDenied} />
                <Route path="/analise" component={acessoAnalise ? Analise : AccessDenied} />
                <Route path="/gestao-credito-solar" component={acessoGestaoCreditoSolar ? GestaoCreditoSolar : AccessDenied} />
                <Route path="/diagnostico-energia" component={acessoDiagnosticoEnergia ? DiagnosticoEnergia : AccessDenied} />
                <Route path="/redes-eletricas" component={acessoRedesEletricas ? RedeVisualizacao : AccessDenied} />
                <Route path="/documento-cliente" component={acessoDocumentoCliente ? DocumentoCliente : AccessDenied} />
                <Route path="/monitoramento-solar" component={acessoGeracaoLeitura ? GeracaoLeitura : AccessDenied} />
                <Route path="/monitoramento-consumo" component={acessoMonitoramentoConsumo ? MonitoramentoConsumo : AccessDenied} />
                <Redirect from="*" to="/dashboard" />
            </Switch>
        </div>
    );
};
